// extracted by mini-css-extract-plugin
module.exports = {"circle":"Avatar_circle__73oAg","rectangle":"Avatar_rectangle__193ZB"};